import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import MemoQuick from "./audit/MemoQuick";
import QuickClassify from "./audit/QuickClassify";
import SharedResultPage from "./audit/SharedResultPage";
import { shareTokenFromPath } from "./audit/shareApi";
import { rememberAgentFlag } from "./audit/AgentInstall";
import { initTheme } from "./audit/useTheme";
import { AuditSearchProvider } from "./audit/AuditSearchContext";
import UpdateBanner from "./components/UpdateBanner";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { setToken } from "./audit/authState";  // 설계 v7 §4-3 래퍼
import { consumeSsoFragment } from "./audit/ssoHandoff";
import { consumeImporterFragment } from "./audit/importerHistory";

// 크로스탭 재사용용 창 이름 — docuai2 등에서 window.open(url,"loginhsHub")로 이 탭을 재사용.
try {
  window.name = "loginhsHub";
} catch (_e) {
  /* noop */
}

// ── SSO: 다른 제품(docuai2·LCS V2)에서 URL 프래그먼트 #sso=<jwt> 로 넘어온 토큰 수신 ──
//   JWT_SECRET 공유라 loginhs-spring 에서 그대로 유효 → 재로그인 없이 자동 로그인.
//   프래그먼트(#)는 서버로 전송/로그되지 않아 안전. render 전에 실행해 App 이 바로 인식.
//   72차: 토큰 안의 신원(sub·groupId·name)까지 저장한다 — 이 브라우저로 처음 오는 사람은
//   groupCode·userId 가 없어 토큰이 있어도 화면이 로그아웃으로 보였다(App 은 세 값을 다 본다).
// 2026-10-06: LCS 신고 화면에서 넘어온 수입자 부호(#…&imp=) — 이 탭에만 기억, SSO 가 조각을 지우기 전에 꺼낸다.
consumeImporterFragment();
consumeSsoFragment({ setToken });

// 페이지 load 시 localStorage 의 배경 테마 적용 — FOUC 방지 (render 전).
initTheme();

const root = ReactDOM.createRoot(document.getElementById("root"));
// mymemo 빠른 메모 창(PC 트레이 에이전트·휴대폰 바로가기) — 앱 셸 없이 이 화면만.
rememberAgentFlag(); // 트레이 앱이 연 화면이면(agent=1) PC 앱 설치 버튼을 숨긴다
const isMemoQuick = new URLSearchParams(window.location.search).has("memo-quick");
const shareToken = shareTokenFromPath();
if (shareToken) {
  // 공유받은 분류 결과(2026-10-06) — /s/토큰, 로그인 없이 앱 셸 없이 한 장.
  root.render(<SharedResultPage token={shareToken} />);
} else if (isMemoQuick) {
  root.render(<MemoQuick />);
} else if (new URLSearchParams(window.location.search).has("hs-quick")) {
  // loginHS 빠른 세번분류 창(PC 트레이 앱 Ctrl+Alt+H, 2026-10-06) — 앱 셸 없이 이 화면만.
  root.render(<QuickClassify />);
} else root.render(
  // 🔧 StrictMode 제거: @react-pdf-viewer 3.12.0이 React 19 StrictMode의
  // 이중 effect 실행(mount→unmount→remount)과 호환되지 않아 'destroy' 에러 발생
  // StrictMode는 개발 모드 전용이며, 프로덕션 빌드에는 영향 없음
  <>
    <AuditSearchProvider>
      <App />
    </AuditSearchProvider>
    <UpdateBanner />
  </>,
);

// PWA 자동 업데이트 — 새 버전 감지 시 상단 [업데이트] 배너(malso 방식).
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    window.__swRegistration = registration;
    window.dispatchEvent(new CustomEvent("sw-update-available"));
  },
});
